import { Box, Container, Typography } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import React from "react";


export default function Plan() {
  return (
    <Container maxWidth="lg" sx={{ marginTop: 11 }}>
          <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold', paddingTop:9 }}>
            Стратегический план
          </Typography>

          <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="strategic plan table">
        <TableHead>
          <TableRow>
            <TableCell colSpan={2} align="center" style={{ fontSize: '14px', color: 'gray' }}>
              16.09.2023
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} align="center" style={{ fontSize: '18px', fontWeight: 'bold' }}>
              РЕСПУБЛИКАЛЫҚ ЖОҒАРЫ ТЕХНИКАЛЫҚ КОЛЛЕДЖ <br />
              РЕСПУБЛИКАНСКИЙ ВЫСШИЙ ТЕХНИЧЕСКИЙ КОЛЛЕДЖ
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} align="center">
              <img 
              src={"/plan.jpeg"}/>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Стратегиялық даму жоспары (қазақ тілінде)
            </TableCell>
            <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Стратегический план развития (русский языке)
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    </Container>
  )
}